export default {
  name: 'SignUpHeader',
}